import Paper from '@material-ui/core/Paper';
import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DataTypeProvider,
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';

import {
  dateFilterPredicate,
  dateFormatter,
} from '../../utilities/dateFormatter';
import { getSelectedClientInformation } from 'utilities/authUtils';

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={dateFormatter} {...props} />
);

const ConfidentialTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={(params) => {
      return params.row.isConfidentialFile ? <FontAwesomeIcon icon="check" /> : "";
    }}
    {...props}
  />
);

class Transferees extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns:
        getSelectedClientInformation().id !== '238'
          ? [
            { name: 'fileId', title: 'Employee ID' },
            { name: 'isConfidentialFile', title: 'Confidential' },
            { name: 'firstName', title: 'First Name' },
            { name: 'lastName', title: 'Last Name' },
            { name: 'fileNumber', title: 'File Number' },
            { name: 'initiationDate', title: 'Initiation Date' },
            { name: 'destinationCity', title: 'Dest City' },
            { name: 'destinationState', title: 'Dest State' },
            { name: 'programType', title: 'Program Type' },
            //{ name: 'Status', title: 'Status' },
            { name: 'fileStatus', title: 'Status'},
          ]
          : [
            { name: 'fileNumber', title: 'TRC ID' },
            { name: 'fileId', title: 'Client ID' },
            { name: 'isConfidentialFile', title: 'Confidential' },
            { name: 'firstName', title: 'Last Name' },
            { name: 'firstName', title: 'First Name' },
            { name: 'initiationDate', title: 'Effective Date' },
            { name: 'programType', title: 'Program Type' },
            //{ name: 'Status', title: 'Status' },
            { name: 'fileStatus', title: 'Status'},
            { name: 'destinationCity', title: 'Dest Work City' },
            { name: 'destinationState', title: 'Dest Work State' },

      ],
      integratedFilteringColumnExtensions: [
        { columnName: 'initiationDate', predicate: dateFilterPredicate },
        // { columnName: 'NewJobStartDate', predicate: dateFilterPredicate },

      ],
      tableColumnExtensions: [
        { columnName: 'fileId', width: 100 },
        { columnName: 'isConfidentialFile', width: 115 },
        { columnName: 'initiationDate', width: 110 },
        { columnName: 'fileNumber', width: 120 },
        { columnName: 'destinationCity', width: 150 },
        { columnName: 'destinationState', width: 90 },
        { columnName: 'fileStatus', width: 150 },
        // { columnName: 'StatusGrouping', width: 150},
      ],
      rows: [],
      currentPage: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50],
      dateColumns: ['initiationDate'],
      confidentialColumns: ['isConfidentialFile'],
      sorting: [{ columnName: 'initiationDate', direction: 'desc' }],
      filters: null,
    };

    this.changeSorting = (sorting) => this.setState({ sorting });

    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });

    this.changeFilters = (filters) => {
      this.setState({ filters });
    };

    this.TableRow = ({ row, handleViewSubmittedAuth, ...restProps }) => {
      return (
        <Table.Row
          {...restProps}
          onClick={() => props.handleViewSubmittedAuth(row.fileId)}
          style={{
            cursor: 'pointer',
          }}
        />
      );
    };
  }

  render() {
    const { rows, initialFilters, hasConfidentialFileAccess } = this.props;
    const {
      columns,
      confidentialColumns,
      pageSize,
      pageSizes,
      currentPage,
      dateColumns,
      filters,
      sorting,
      integratedFilteringColumnExtensions,
      tableColumnExtensions,
    } = this.state;
      const useFilters = filters ? filters : initialFilters ? initialFilters : [];

    return (
      <Paper style={{ padding: '1rem' }}>
        {/* <div style={{ padding: '1rem', fontSize: '1.25rem' }}>My Transferees</div> */}
        <Grid rows={rows} columns={hasConfidentialFileAccess ? columns : columns.filter(c => c.name !== 'isConfidentialFile')}>
          <DateTypeProvider for={dateColumns} />
          <ConfidentialTypeProvider for={confidentialColumns} />
          <SortingState
            sorting={sorting}
            onSortingChange={this.changeSorting}
          />
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={this.changeCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={this.changePageSize}
          />
          <IntegratedSorting />
          <FilteringState
            filters={useFilters}
            onFiltersChange={this.changeFilters}
          />
          <IntegratedFiltering
            columnExtensions={integratedFilteringColumnExtensions}
          />
          <IntegratedPaging />
          <Table
            rowComponent={this.TableRow}
            columnExtensions={tableColumnExtensions}
          />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <PagingPanel pageSizes={pageSizes} />
        </Grid>
      </Paper>
    );
  }
}

export default Transferees;
